import { useState } from 'react';
import { createMap } from '../../api/client';

export default function NewMapModal({ activeClient, onClose, onCreated }) {
  const [name, setName] = useState('');
  const [measurement, setMeasurement] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    if (!name.trim() || !measurement.trim()) {
      setError('All fields are required');
      return;
    }
    setSaving(true);
    setError('');

    try {
      const newMap = await createMap({
        name: name.trim(),
        clientId: activeClient.id,
        measurement: measurement.trim(),
      });
      onCreated(newMap);
    } catch (err) {
      setError(err.message || 'Failed to create map');
      setSaving(false);
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />

      <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-lg p-6">
        <h2 className="text-xl font-heading font-semibold text-txt-primary mb-1">
          New Clarity Map
        </h2>
        <p className="text-sm text-txt-secondary mb-5">
          for {activeClient.name}
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-txt-secondary mb-1">
              What do you need to get clear on?
            </label>
            <input
              type="text"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g., Q1 Product Launch Keynote"
              autoFocus
              className="w-full rounded-lg border-gray-300 shadow-sm
                focus:border-gold focus:ring-gold text-sm"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-txt-secondary mb-1">
              What does success look like?
            </label>
            <p className="text-xs text-txt-secondary mb-2 italic">
              What would tell you this worked?
            </p>
            <textarea
              required
              value={measurement}
              onChange={(e) => setMeasurement(e.target.value)}
              rows={3}
              placeholder="e.g., The VP of Sales greenlights the new territory plan within 48 hours"
              className="w-full rounded-lg border-gray-300 shadow-sm
                focus:border-gold focus:ring-gold text-sm resize-none"
            />
          </div>

          {error && (
            <p className="text-red-500 text-sm">{error}</p>
          )}

          <div className="flex items-center justify-end gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-txt-secondary
                hover:text-txt-primary transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={saving}
              className="btn-gold disabled:opacity-50"
            >
              {saving ? 'Creating...' : 'Create Map'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
